import { IS_PREVIEW } from './environment';
const SITE_NAME = 'FlightFormula';
const DEFAULT_DESCRIPTION =
  'FlightFormula tools and guides for Qantas points, reward flights, wine and marketplace deal tracking.';

export function normalizePathname(input) {
  if (!input) return '/';

  let path = String(input).trim();
  if (!path) return '/';

  try {
    if (/^https?:\/\//i.test(path)) {
      path = new URL(path).pathname || '/';
    }
  } catch (_error) {
    // Fall through to string-based cleanup for partial or invalid URLs.
  }

  path = path.split('#')[0].split('?')[0] || '/';
  path = path.replace(/\/{2,}/g, '/');

  if (!path.startsWith('/')) {
    path = `/${path}`;
  }

  if (path.length > 1) {
    path = path.replace(/\/+$/, '');
  }

  return path || '/';
}

function upsertMeta({ name, property, content }) {
  if (!content) return;
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let node = document.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    if (name) node.setAttribute('name', name);
    if (property) node.setAttribute('property', property);
    document.head.appendChild(node);
  }
  node.setAttribute('content', content);
}

function upsertCanonical(href) {
  if (!href) return;
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', href);
}

function formatTitle(title) {
  if (!title) return SITE_NAME;
  return title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
}

const DEFAULT_IMAGE_PATH = '/logo512.png';
let lastOwnedPath = null;

// Pages that call applySeo own the metadata for their path. The layout's
// route defaults must not overwrite them (child effects run before parent effects).
export function applyDefaultSeo(options) {
  const normalizedPath = normalizePathname(options.canonicalPath || window.location.pathname);
  if (lastOwnedPath === normalizedPath) return;
  applySeo({ ...options, canonicalPath: normalizedPath, __default: true });
}

export function applySeo({
  title,
  description,
  robots = 'index,follow',
  ogType = 'website',
  canonicalPath,
  image,
  __default = false,
}) {
  const finalTitle = formatTitle(title);
  const finalDescription = description || DEFAULT_DESCRIPTION;
  const normalizedPath = normalizePathname(canonicalPath || window.location.pathname);
  if (!__default) lastOwnedPath = normalizedPath;
  const finalImage = image || `${window.location.origin}${DEFAULT_IMAGE_PATH}`;

  document.title = finalTitle;
  upsertMeta({ name: 'description', content: finalDescription });
  upsertMeta({ name: 'robots', content: IS_PREVIEW ? 'noindex,nofollow' : robots });
  upsertMeta({ property: 'og:title', content: finalTitle });
  upsertMeta({ property: 'og:description', content: finalDescription });
  upsertMeta({ property: 'og:type', content: ogType });
  upsertMeta({ property: 'og:url', content: `${window.location.origin}${normalizedPath}` });
  upsertMeta({ property: 'og:image', content: finalImage });
  upsertMeta({ name: 'twitter:image', content: finalImage });
  upsertMeta({ name: 'twitter:card', content: 'summary_large_image' });
  upsertMeta({ name: 'twitter:title', content: finalTitle });
  upsertMeta({ name: 'twitter:description', content: finalDescription });

  if (normalizedPath.startsWith('/')) {
    upsertCanonical(`${window.location.origin}${normalizedPath}`);
  }
}
